import styles from './FJPreviewInfo.module.less';
import FJAvatarInfo from './components/FJAvatarInfo.jsx';
import FJGenerateIcon from '../../../../assets/svg/community/go-to-generate.svg?react';
import FJDownloadIcon from '../../../../assets/svg/download.svg?react';
import FJAddToMediaIcon from '../../../../assets/svg/add-to-media.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJButton, { FJButtonType } from '../../../../common/components/FJButton/FJButton.jsx';
import FJGenerateInfo from './components/FJGenerateInfo.jsx';
import FJFooter from './components/FJFooter.jsx';
import FJConstant from '../../../../constants/FJConstant.js';
import PropTypes from 'prop-types';
import FJUtil from '../../../../util/FJUtil.js';

const FJPreviewInfo = props => {
    const {
        onDownload,
        shareToSociety,
        onEdit,
        stateIsDownloadLoading,
        data,
        videoEffectStyleList,
        onDelete,
        onLike,
        onPrivacySettingChange,
        onRecreate,
        onReport,
        onAddToMedia,
    } = props;
    const { previewType = FJConstant.TOOL_PREVIEW } = data;

    const isToolPreview = previewType === FJConstant.TOOL_PREVIEW;

    const _onClick = () => {
        if (isToolPreview && FJUtil.isEditPage()) {
            onAddToMedia();
        } else if (isToolPreview) {
            onDownload();
        } else {
            onRecreate();
        }
    };
    const btnText = isToolPreview ? (FJUtil.isEditPage() ? 'add-to-media' : 'download') : 'recreate';
    const btnIcon = isToolPreview ? (
        FJUtil.isEditPage() ? (
            <FJAddToMediaIcon />
        ) : (
            <FJDownloadIcon />
        )
    ) : (
        <FJGenerateIcon />
    );
    return (
        <div className={styles.box}>
            <FJAvatarInfo info={data} />
            <FJButton
                className={styles.btn}
                textClassName={styles.btn_text}
                icon={btnIcon}
                text={FJLocalStore._(btnText)}
                onClick={_onClick}
                type={FJButtonType.GRADIENT}
                isLoading={stateIsDownloadLoading}
                strokeColor={'#FFF'}
            />
            <FJGenerateInfo info={data} videoEffectStyleList={videoEffectStyleList} />
            <FJFooter
                shareToSociety={shareToSociety}
                onEdit={onEdit}
                onDownload={onDownload}
                info={data}
                onDelete={onDelete}
                onLike={onLike}
                onPrivacySettingChange={onPrivacySettingChange}
                onReport={onReport}
            />
        </div>
    );
};

FJPreviewInfo.propTypes = {
    onDownload: PropTypes.func,
    shareToSociety: PropTypes.func,
    onEdit: PropTypes.func,
    stateIsDownloadLoading: PropTypes.bool,
    data: PropTypes.object,
    videoEffectStyleList: PropTypes.array,
    onDelete: PropTypes.func,
    onLike: PropTypes.func,
    onPrivacySettingChange: PropTypes.func,
    onRecreate: PropTypes.func,
    onReport: PropTypes.func,
    onAddToMedia: PropTypes.func,
};

export default FJPreviewInfo;
